export default __webpack_public_path__ + "static/media/164.880a813c.gif";